import { memo, useCallback } from 'react';
import { Snackbar, Slide } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Alert from '@mui/material/Alert';
import { useSelector, useDispatch, hideNotification } from '../../state';
import { useIsMobile } from '../../hooks';

function NotificationTransition(props) {
  const isMobile = useIsMobile();
  return <Slide {...props} direction={isMobile ? 'right' : 'left'} />;
}

export const Notification = memo(() => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const isMobile = useIsMobile();

  const notification = useSelector((state) => state.ui.notification);
  const {
    message,
    variant = 'success',
    duration = variant === 'error' ? 8000 : 6000,
  } = notification || {};

  const onClose = useCallback(
    (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      dispatch(hideNotification());
    },
    [dispatch],
  );

  return (
    <Snackbar
      anchorOrigin={
        isMobile
          ? { vertical: 'top', horizontal: 'left' }
          : { vertical: 'bottom', horizontal: 'right' }
      }
      autoHideDuration={duration}
      open={!!notification}
      onClose={onClose}
      // need this to remove it from blocking buttons after being closed
      style={{ visibility: notification ? 'visible' : 'hidden' }}
      slots={{
        transition: NotificationTransition,
      }}
    >
      <Alert
        variant='standard'
        severity={variant}
        onClose={onClose}
        classes={{ root: classes.paper }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
});

const useStyles = makeStyles()((theme) => ({
  paper: {
    borderRadius: 3,
    fontSize: 13,
    // backgroundColor: '#FFFFFF',
  },
  icon: {
    color: '#D5D8EC',
    fontSize: 18,
  },
}));
